import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import EventCard from "@/components/EventCard";

const FILTERS = [
  { key: "all", label: "ALL" },
  { key: "week", label: "THIS WEEK" },
  { key: "weekend", label: "THIS WEEKEND" },
  { key: "month", label: "THIS MONTH" },
];

export default function Events() {
  const [filter, setFilter] = useState("all");
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/events?filter=${filter}`).then((r) => setEvents(r.data)).catch(() => setEvents([])).finally(() => setLoading(false));
  }, [filter]);

  return (
    <div className="mx-auto max-w-6xl px-4 sm:px-6 py-10">
      <span className="section-eyebrow">Huntsville, AL</span>
      <h1 className="font-display text-4xl sm:text-5xl uppercase text-white mt-2 mb-6 leading-none">All Events</h1>

      <div className="flex gap-2 overflow-x-auto no-scrollbar pb-2 mb-8">
        {FILTERS.map((f) => (
          <button
            key={f.key}
            data-testid={`filter-${f.key}`}
            onClick={() => setFilter(f.key)}
            className={`whitespace-nowrap rounded-full px-4 py-2 font-oswald text-xs font-semibold tracking-widest transition-colors ${
              filter === f.key ? "bg-[#D4AF37] text-black" : "border border-[#27272A] text-zinc-300 hover:border-[#D4AF37]"
            }`}
          >
            {f.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="aspect-[4/5] rounded-xl bg-[#141417] animate-pulse" />
          ))}
        </div>
      ) : events.length === 0 ? (
        <div className="rounded-xl border border-[#27272A] p-14 text-center">
          <p className="font-display text-2xl text-white uppercase">No Events Found</p>
          <p className="text-zinc-400 mt-1 text-sm">Try a different filter — new events are coming soon.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="events-grid">
          {events.map((ev) => (
            <EventCard key={ev.id} event={ev} />
          ))}
        </div>
      )}
    </div>
  );
}
